<template>
  <div>
    <div class="container-fluid mt-6"
         v-if="course && course.related_course_1">
      <div class="container">
        <div class="row">
          <div class="col-12 related-header">
            {{ $t('learn_course_with', {course: course.course}) }}:
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid"
         v-if="course && course.related_course_1">
      <div class="container mt-6">
        <div class="row justify-content-center">
          <div class="col-lg-3 col-6" v-if="course1">
            <CourseRelatedItem :course="course1"/>
          </div>
          <div class="col-lg-3 col-6" v-if="course2">
            <CourseRelatedItem :course="course2"/>
          </div>
          <div class="col-lg-3 col-6" v-if="course3">
            <CourseRelatedItem :course="course3"/>
          </div>
          <div class="col-lg-3 col-6" v-if="course4">
            <CourseRelatedItem :course="course4"/>
          </div>
          <div class="col-lg-3 col-6" v-if="course5">
            <CourseRelatedItem :course="course5"/>
          </div>
          <div class="col-lg-3 col-6" v-if="course6">
            <CourseRelatedItem :course="course6"/>
          </div>
        </div>
      </div><!-- /.container -->
    </div><!-- /.container-fluid -->
  </div>
</template>

<script>

import courseApi from "../../data/CourseApi";
import CourseRelatedItem from './CourseRelatedItem';

export default {
  name: 'CourseRelated',

  components: {
    CourseRelatedItem
  },

  props: {
    course: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      course1: null,
      course2: null,
      course3: null,
      course4: null,
      course5: null,
      course6: null,
    }
  },

  computed: {
    relatedCount: function () {
      let count = 0;
      if (this.course.related_course_1) count++;
      if (this.course.related_course_2) count++;
      if (this.course.related_course_3) count++;
      if (this.course.related_course_4) count++;
      if (this.course.related_course_5) count++;
      if (this.course.related_course_6) count++;
      return count;
    },
  },

  watch: {
    course: function () {
      this.fetchRelated()
    },
  },


  mounted() {
    this.fetchRelated()
  },

  methods: {
    fetchRelated() {
      if (this.course) {
        if (this.course.related_course_1) {
          courseApi.fetchCourse(this.course.related_course_1).then(response => {
            this.course1 = response
            console.log(this.course1)
          })
        }
        if (this.course.related_course_2) {
          courseApi.fetchCourse(this.course.related_course_2).then(response => {
            this.course2 = response
            console.log(this.course2)
          })
        }
        if (this.course.related_course_3) {
          courseApi.fetchCourse(this.course.related_course_3).then(response => {
            this.course3 = response
          })
        }
        if (this.course.related_course_4) {
          courseApi.fetchCourse(this.course.related_course_4).then(response => {
            this.course4 = response
          })
        }
        if (this.course.related_course_5) {
          courseApi.fetchCourse(this.course.related_course_5).then(response => {
            this.course5 = response
          })

        }
        if (this.course.related_course_6) {
          courseApi.fetchCourse(this.course.related_course_6).then(response => {
            this.course6 = response
          })
        }
      }
    }

  }

}
</script>
<style scoped>

.related-header {
  font-family: "Manrope Bold";
  font-size: 30px;
  color: #231c37;
  line-height: 24px;
  text-align: center;
}


@media (min-width: 992px) {

}


@media (max-width: 991.8px) {

}
</style>
